import React from 'react';
import { cn } from '@/lib/utils';

interface MomentsSkeletonProps {
  count?: number;
  viewMode?: 'list' | 'grid';
  className?: string;
}

const MomentsSkeleton: React.FC<MomentsSkeletonProps> = ({ 
  count = 6,
  viewMode = 'list',
  className
}) => {
  return (
    <div className={cn('grid gap-4', {
      'grid-cols-1': viewMode === 'list',
      'grid-cols-3': viewMode === 'grid'
    }, className)}>
      {Array.from({ length: count }).map((_, index) => (
        viewMode === 'list' ? (
          <div
            key={index}
            className="bg-dark-200 rounded-xl border border-dark-300 overflow-hidden animate-pulse flex flex-col"
          >
            {/* Image Placeholder */}
            <div className="aspect-video w-full bg-dark-300 flex-shrink-0" />
            
            {/* Content */}
            <div className="p-4 flex flex-col">
              {/* Timestamp */}
              <div className="h-3 w-24 bg-dark-300 rounded mb-4" />
              
              {/* Content Placeholder */}
              <div className="space-y-2 mb-4">
                <div className="h-4 w-3/4 bg-dark-300 rounded" />
                <div className="h-4 w-1/2 bg-dark-300 rounded" />
              </div>
              
              {/* Action Buttons */}
              <div className="flex items-center space-x-6 mt-4 pt-4 border-t border-dark-300">
                <div className="h-5 w-16 bg-dark-300 rounded" />
                <div className="h-5 w-16 bg-dark-300 rounded" />
                <div className="h-5 w-5 bg-dark-300 rounded-full ml-auto" />
              </div>
            </div>
          </div>
        ) : (
          <div
            key={index}
            className="aspect-square rounded-xl border border-dark-300 overflow-hidden animate-pulse bg-dark-300"
          />
        )
      ))}
    </div>
  );
};

export default MomentsSkeleton;